import { create } from "zustand";

export const refetchState = create<{
	lastFetch: number;
	needsFetch: number;
	setLastFetch: (n: number) => void;
	setNeedsFetch: (n: number) => void;
	// Number of fetches currently running.
	// At each start: incr, but do NOT forget to decr when finished!
	isFetching: number;
	incrIsFetching: () => void;
	decrIsFetching: () => void;
}>((set) => ({
	lastFetch: 0,
	needsFetch: 1,
	setNeedsFetch(needsFetch: number) {
		set({ needsFetch });
	},
	setLastFetch(lastFetch: number) {
		set({ lastFetch });
	},
	isFetching: 0,
	incrIsFetching() {
		set(({ isFetching }) => ({ isFetching: isFetching + 1 }));
	},
	decrIsFetching() {
		set(({ isFetching }) => ({ isFetching: isFetching - 1 }));
	},
}));
